import type { ConditionalFormattingRule } from '../store/schema/ConditionalFormattingRule';
import type { ConditionalFormattingScenario } from '../store/schema/ConditionalFormattingScenarioType';
import { getConditionalFormattingStore } from '../store/store';
import type { MailboxInfo } from 'owa-client-types';
import { getEnterpriseOrPremiumLicenseStatus } from 'owa-has-enterprise-or-premium-license-store';
import { isConditionSupportedForScenario } from '../utils/conditionalFormattingConditionTypeUtils';

export default function getApplicableConditionalFormattingRulesByMailbox(
    mailboxInfo: MailboxInfo,
    scenario: ConditionalFormattingScenario
): ConditionalFormattingRule[] {
    if (getEnterpriseOrPremiumLicenseStatus() !== 'HasEnterpriseOrPremiumLicense') {
        return [];
    }

    const rules = getConditionalFormattingStore(mailboxInfo, scenario).conditionalFormattingRules;
    return rules.filter(
        rule =>
            !rule.conditions.some(
                condition => !isConditionSupportedForScenario(condition.type, scenario)
            )
    );
}
